// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","blue":"#00afef","grey-light":"#c9c9c9"};